import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class Icon extends Component {
    static propTypes = {
        className: PropTypes.string,
        name: PropTypes.string.isRequired,
        rotate: PropTypes.oneOf([ 90, 180, 270 ]),
        size: PropTypes.oneOf([ 'lg', '2x', '3x', '4x', '5x' ]),
        spin: PropTypes.bool,
        fixedWidth: PropTypes.bool,
    }

    render() {
        const { fixedWidth, name, rotate, size, spin, ...props } = this.props;

        let className = 'fa fa-' + name;

        if (fixedWidth) className += ' fa-fw';
        if (size) className += ' fa-' + size;
        if (spin) className += ' fa-spin';
        if (rotate) className += ' fa-rotate-' + rotate;

        if (this.props.className) {
            className += ' ' + this.props.className;
        }

        return (
            <span {...props} className={className} />
        );
    }
}
